(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-cupcakes"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-flavor"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    
  class ScrollToTopComponent extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.scroll-to-top__button');
    }

    connectedCallback() {
      this.button.addEventListener('click', this.scrollToTop.bind(this));
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.scrollToTop);
    }

    scrollToTop(event) {
      event.preventDefault();
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('scroll-to-top-component', ScrollToTopComponent);

  } catch(e) { console.error(e); }
})();
})();
